var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nvaHead"},[(_vm.goback)?_c('div',{staticClass:"backIcon",on:{"click":_vm.toBack}},[_c('svg-icon',{attrs:{"icon-class":"back"}})],1):_vm._e(),_c('div',{staticClass:"pageTitle"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }